import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Logo } from "./Logo";
import { LanguageSwitcher } from "./LanguageSwitcher";

const LINKS = ["about", "offer", "vehicles", "brands", "why", "contact"];
const hrefFor = (k) => (k === "vehicles" ? "/vehicles" : `/#${k}`);

export const Header = () => {
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header data-testid="site-header" className={`sticky top-0 z-50 backdrop-blur-xl transition-[background-color,box-shadow] duration-300 ${scrolled ? "bg-[#060A14]/85 shadow-[0_1px_0_rgba(255,255,255,.06)]" : "bg-[#060A14]/40"}`}>
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8">
        <a href="/#top" data-testid="header-logo-link"><Logo /></a>
        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((k) => (
            <a key={k} href={hrefFor(k)} data-testid={`nav-link-${k}`} className="relative text-[15px] font-semibold text-white after:absolute after:-bottom-1.5 after:left-0 after:h-[2px] after:w-0 after:bg-[#2F7BFF] after:transition-[width] hover:after:w-full">
              {t.nav[k]}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <a href="/#contact" data-testid="header-cta-button" className="hidden rounded-full bg-[#2F7BFF] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#1F63E0] sm:inline-flex">
            {t.nav.cta}
          </a>
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="rounded-lg p-2 text-white lg:hidden" aria-label="Menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="border-t border-white/10 bg-[#060A14] px-5 py-4 lg:hidden">
          {LINKS.map((k) => (
            <a key={k} href={hrefFor(k)} onClick={() => setOpen(false)} data-testid={`mobile-nav-link-${k}`} className="block py-3 text-base font-semibold text-white">
              {t.nav[k]}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};
